var mapDefaultArgs = {
  showRestaurant: true,
  lat: 45.116177,
  lon: 7.742615,
  approximateLat: 45.116177,
  approximateLon: 7.742615
};
export { mapDefaultArgs };